import { Mouvement } from '@mairistem/comptabilite';
import MouvementActionType from '../../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import BaseLiquidationAction from '../../../pieces/BaseLiquidationAction';
import ActionResultType from '../../../../interfaces/pieces/ActionResultType';
import TreeviewActionResult from '../../../../interfaces/pieces/TreeviewActionResult';
import type { BaseLiquidationOptions } from '../../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';

class MouvementModifierAction extends BaseLiquidationAction<Mouvement, MouvementActionType> {
  isReadonly: boolean;

  constructor(options: BaseLiquidationOptions & { isReadonly?: boolean } = null) {
    super(options);
    this.isReadonly = options?.isReadonly;
    this.label = options?.isReadonly ? 'Afficher' : 'Modifier';
    this.type = options?.isReadonly ? MouvementActionType.SHOW_MOUVEMENT : MouvementActionType.UPDATE_MOUVEMENT;
  }

  execute = (mouvement: Mouvement): TreeviewActionResult<Mouvement> => ({
    type: ActionResultType.LINK,
    result: Promise.resolve(mouvement),
    extraProps: {
      link: {
        typeAction: this.type,
        readonly: this.isReadonly,
      },
    },
  });
}

export default MouvementModifierAction;
